export const ar = {
  pageTitle: "العملاء",
  pageSubtitle: "عرض العملاء والطلبات الحديثة ونشاط المتابعة.",
  errorNotFound: "لم يتم العثور على العميل",
  openInShopify: "فتح في Shopify ←",
  activityOutcomePending: "قيد الانتظار",
  filters: {
    all: "الكل",
    hasOpenActivity: "لديه نشاط مفتوح",
    vipOnly: "VIP فقط",
  },
  sort: {
    latestActivity: "أحدث نشاط",
    name: "الاسم",
    lastOrder: "آخر طلب",
    openActivities: "المهام المفتوحة",
  },
  columns: {
    customer: "العميل",
    phone: "الهاتف",
    lastOrder: "آخر طلب",
    openActivities: "المهام المفتوحة",
    latestActivityUpdate: "آخر تحديث للنشاط",
    latestUpdate: "آخر تحديث",
  },
  stats: {
    lifetimeSales: "إجمالي المبيعات",
    completedOrders: "الطلبات المكتملة",
    lastOrder: "آخر طلب",
    openActivities: "المهام المفتوحة",
    orders: "الطلبات",
  },
  tabs: {
    recentOrders: "الطلبات الحديثة",
    activities: "المهام",
  },
  empty: {
    notFound: "لم يتم العثور على عملاء",
    orders: "لا توجد طلبات",
    activities: "لا توجد مهام",
    title: "لم يتم العثور على عملاء",
    description: "لا يوجد عملاء لعرضهم.",
    filteredDescription: "لا يوجد عملاء يطابقون عوامل التصفية أو البحث. حاول تعديلها.",
  },
  pagination: {
    itemLabel: "عملاء",
  },
  error: {
    loadFailed: "فشل تحميل العملاء.",
    retry: "إعادة المحاولة",
  },
  order: {
    itemSingular: "عنصر",
    itemPlural: "عناصر",
    orderDate: "تاريخ الطلب",
    paymentMethod: "طريقة الدفع",
    source: "المصدر",
    tags: "الوسوم",
    lineItems: "عناصر الطلب ({{count}})",
    lastUpdated: "آخر تحديث {{date}}",
    loadingDetails: "جارٍ تحميل تفاصيل الطلب...",
    errorTitle: "خطأ",
    errorLoadFailed: "فشل تحميل تفاصيل الطلب.",
    retry: "إعادة المحاولة",
    sources: {
      web: "الويب",
      pos: "نقطة البيع",
      shopify_draft_order: "طلب مسودة",
      subscription_contract: "اشتراك",
      iphone: "iPhone",
      android: "Android",
      shopify_mobile: "Shopify Mobile",
      point_of_sale: "نقطة البيع",
      shop: "المتجر",
      api: "API",
      webhook: "Webhook",
    },
  },
  orderStatus: {
    fulfilled: "تم التنفيذ",
    unfulfilled: "لم يتم التنفيذ",
    partially_fulfilled: "تم التنفيذ جزئياً",
    restocked: "تمت الإعادة للمخزون",
    open: "مفتوح",
    cancelled: "ملغي",
    refunded: "مسترد",
    partial: "تم التنفيذ جزئياً",
    pending: "قيد الانتظار",
    on_hold: "معلق",
  },
} as const;
